module.exports = __webpack_public_path__ + "img/headshot-andrea-maida@2x.c950e468.jpg";